import { useAuth } from "./contexts/AuthContext";
import { useLoader } from "./contexts/LoaderContext";


const apiClient = () => {
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_VERSION = "v1";
  const { accessToken, refreshAccessToken } = useAuth();
  const { showLoader, hideLoader } = useLoader(); 

  const request = async (method, endpoint, data = null, config = {}, isRetry = false, responseType = "json") => {
    try {
      showLoader();
      const api_url = `${REACT_APP_API_BASE_URL}/${API_VERSION}${endpoint}`;
      const whiteListedEndPoints = [
        "/user/login",
        "/user/validate-user",
        "/user/reset-password"
      ];

      const headers = config.headers || {};
      const isFormData = data instanceof FormData;
      if (!isFormData && !headers['Content-Type']) {
        headers["Content-Type"] = "application/json";
        data = data ? JSON.stringify(data) : null;
      }

      if (!whiteListedEndPoints.includes(endpoint) && !accessToken) {
        throw new Error("User is not authenticated");
      }
      if (!whiteListedEndPoints.includes(endpoint) && accessToken && !headers["Authorization"]) {
        headers["Authorization"] = `Bearer ${accessToken}`;
      }

      const response = await fetch(api_url, {
        method,
        headers: headers,
        body: data
      });
      
      if (response.status === 401 || response.status === 403) {
        if (!isRetry) {          
          const newToken = await refreshAccessToken();
          if (newToken) {            
            const updatedHeaders = {
              ...headers,
              Authorization: `Bearer ${newToken}`
            };                                  
            return await request(method, endpoint, data, { headers: updatedHeaders }, true, responseType);
          }
        }        
      }

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        const error = new Error(errorBody.message || "API request failed");
        error.status = response.status;
        error.details = errorBody;        
        throw error;
      }     
      
      switch (responseType) {
        case "blob":
            return await response.blob(); // Return binary file
        case "text":
            return await response.text(); // Return plain text
        default:
            return await response.json(); // Default to JSON
    }
      return response.json();
    }
    catch (error) {      
      throw error;
    }
    finally {
      hideLoader();
    }  
  };
  return { request };
};

export default apiClient;
